import { useEffect, useState } from 'react';
import api from '../../api/axios';

const IMAGE_EXT = /\.(jpg|jpeg|png|gif|webp|svg)$/i;

export default function S3ImagePicker({ onSelect, onClose }) {
  const [folders, setFolders] = useState([]);
  const [folder, setFolder] = useState('');
  const [files, setFiles] = useState([]);
  const [loadingFolders, setLoadingFolders] = useState(true);
  const [loadingFiles, setLoadingFiles] = useState(false);

  useEffect(() => {
    api.get('/media/folders')
      .then(r => { setFolders(r.data || []); if (r.data?.length) setFolder(r.data[0]); })
      .finally(() => setLoadingFolders(false));
  }, []);

  useEffect(() => {
    if (!folder) return;
    setLoadingFiles(true);
    api.get(`/media/files?prefix=${encodeURIComponent(folder)}`)
      .then(r => setFiles((r.data || []).filter(f => IMAGE_EXT.test(f.name))))
      .finally(() => setLoadingFiles(false));
  }, [folder]);

  return (
    <div className="modal d-block" style={{ background: 'rgba(0,0,0,0.5)', zIndex: 1090 }}>
      <div className="modal-dialog modal-xl modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title fw-bold">Select from Media</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            {loadingFolders ? (
              <div className="text-center py-4"><div className="spinner-border text-primary"></div></div>
            ) : (
              <>
                <div className="mb-3">
                  <label className="form-label small fw-bold">Folder</label>
                  <select className="form-select" value={folder} onChange={e => setFolder(e.target.value)}>
                    {folders.length === 0 && <option value="">No folders found</option>}
                    {folders.map(f => <option key={f} value={f}>{f}</option>)}
                  </select>
                </div>
                {loadingFiles ? (
                  <div className="text-center py-4"><div className="spinner-border text-primary"></div></div>
                ) : files.length === 0 ? (
                  <p className="text-muted text-center py-4">No images in this folder.</p>
                ) : (
                  <div className="row g-2">
                    {files.map(f => (
                      <div key={f.key} className="col-6 col-sm-4 col-md-3 col-lg-2">
                        <div className="border rounded overflow-hidden position-relative" style={{ cursor: 'pointer', aspectRatio: '1' }}
                          onClick={() => { onSelect(f.url); onClose(); }} title={f.name}>
                          <img src={f.url} alt={f.name} className="w-100 h-100" style={{ objectFit: 'cover' }} />
                          <div className="position-absolute bottom-0 start-0 end-0 px-1 py-1" style={{ background: 'rgba(0,0,0,0.45)', fontSize: '10px', color: '#fff' }}>
                            <span className="text-truncate d-block">{f.name}</span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-outline-secondary rounded-pill px-4" onClick={onClose}>Cancel</button>
          </div>
        </div>
      </div>
    </div>
  );
}
